import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-alert-dialog',
    templateUrl: '../../pages/alert-dialog/alert-dialog.component.html'
})
export class AlertDialogComponent 
{
    message: string = ""
    cancelButtonText = "Cancel"
    clase = ""

    constructor( @Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<AlertDialogComponent>) 
    {
        if (data) 
        {
            this.message = data.message || this.message;
            this.clase = data.clase;
            
            if (data.buttonText) { this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText; } 
        }

        this.dialogRef.updateSize('300vw','300vw')
    }

    onConfirmClick(): void { this.dialogRef.close(true); }
}